import React from 'react';
import { useSelector } from 'react-redux';
import { ModalHeader } from '../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalCloseButton } from '../../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalBody } from '../../../../CommonComponents/OPL/Modal/ModalBody';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { Modal } from '../../../../CommonComponents/OPL/Modal/Modal';
import { TransferType } from '../../TransferMoney.types';
import { VisualPickerButton } from '../../../../CommonComponents/OPL/VisualPickerButton/VisualPickerButton';
import { selectShowApexAcatsTransferFlow } from '../../../../CommonSelectors/CommonAreaSelector';

const options = [
  {
    value: TransferType.Deposit,
    label: 'Deposit money into your account',
    icon: 'far fa-arrow-circle-down',
  },
  {
    value: TransferType.Withdraw,
    label: 'Withdraw money from your account',
    icon: 'far fa-arrow-circle-up',
  },
  {
    value: TransferType.TransferAccount,
    label: 'Transfer-in brokerage account or IRA',
    icon: 'far fa-exchange',
  },
];

interface Props {
  onSelection(transferType: TransferType): void;
  onClose(): void;
}

export const Selection: React.FC<Props> = ({ onSelection, onClose }) => {
  const showApexAcatsTransferFlow = useSelector(selectShowApexAcatsTransferFlow);

  return (
    <Modal isOpen onRequestClose={onClose}>
      <ModalHeader>Transfer Money</ModalHeader>
      <ModalCloseButton onClick={onClose} />

      <ModalBody>
        <Box display="flex" flexDirection="column" mt="12">
          {options.map(({ value, label, icon }) => {
            if (value === TransferType.TransferAccount && !showApexAcatsTransferFlow) {
              return null;
            }

            return (
              <VisualPickerButton
                key={value}
                icon={icon}
                onClick={() => onSelection(value)}
                mb="16"
              >
                {label}
              </VisualPickerButton>
            );
          })}
        </Box>
      </ModalBody>
    </Modal>
  );
};
